<jb-dialog dialogType="content" contentModalWidth="80%" #dlg>
  <jb-dialog-header *ngIf="!isMobile">
    {{ content?.citySelector?.regionsCopy?.title }}
  </jb-dialog-header>
  <jb-dialog-content #dialogContent>
    <dot-region-selector-v2
      #regionSelector
      [label]="label"
      [content]="content"
      [control]="control"
      [regions]="regions"
      [countries]="countries"
      [groupedAirports]="groupedAirports"
      [citySelector]="citySelector"
      [formWrapper]="formWrapper"
      [filterOutPartner]="filterOutPartner"
      [hideLegend]="hideLegend"
      [customLegendMessage]="customLegendMessage"
      [separatePartnerCities]="separatePartnerCities"
      (backButtonClick)="dlg.handleCloseModal($event)"
    >
    </dot-region-selector-v2>
  </jb-dialog-content>
  <jb-dialog-actions> </jb-dialog-actions>
</jb-dialog>
